var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.49992L11.825 6.31659L6.33333 11.8083L4.175 9.65825L3 10.8333L6.33333 14.1666L13 7.49992ZM13.8333 2.49992H10.35C10 1.53325 9.08333 0.833252 8 0.833252C6.91667 0.833252 6 1.53325 5.65 2.49992H2.16667C2.05 2.49992 1.94167 2.50825 1.83333 2.53325C1.56793 2.58894 1.32003 2.70829 1.11099 2.88104C0.901951 3.05379 0.738027 3.27476 0.633333 3.52492C0.55 3.71659 0.5 3.93325 0.5 4.16659V15.8333C0.5 16.0583 0.55 16.2833 0.633333 16.4833C0.716667 16.6833 0.841667 16.8583 0.991667 17.0166C1.21667 17.2416 1.50833 17.4083 1.83333 17.4749C1.94167 17.4916 2.05 17.4999 2.16667 17.4999H13.8333C14.75 17.4999 15.5 16.7499 15.5 15.8333V4.16659C15.5 3.24992 14.75 2.49992 13.8333 2.49992ZM8 2.29159C8.34167 2.29159 8.625 2.57492 8.625 2.91659C8.625 3.25825 8.34167 3.54159 8 3.54159C7.65833 3.54159 7.375 3.25825 7.375 2.91659C7.375 2.57492 7.65833 2.29159 8 2.29159ZM13.8333 15.8333H2.16667V4.16659H13.8333V15.8333Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.a5decc47227baf3e7e2b6069c20bdbeb.svg";
export { ForwardRef as ReactComponent };